module.exports = __webpack_public_path__ + "static/media/login-page.a0eeb957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/login-page.jpg
// module id = 3830
// module chunks = 1